import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const baseReviewConfig = {
  AU: {
      provider: 'bazaarvoice',
      client_name: 'delonghi-anz',
      site_id: 'main_site',
  },
  NZ: {
      provider: 'bazaarvoice',
      client_name: 'delonghi-anz',
      site_id: 'main_site',
  },
  US: {
      provider: 'bazaarvoice',
      client_name: 'delonghiresponse',
      site_id: 'main_site',
  },
  CA: {
      provider: 'bazaarvoice',
      client_name: 'delonghiresponse',
      site_id: 'main_site',
  },
  FR: {
      provider: 'bazaarvoice',
      client_name: 'delonghi-fr',
      site_id: 'main_site',
  },
  WW: {
      provider: 'feefo',
      client_name: '',
      site_id: '',
      environment: 'development'
  },
}

// const specialCountryMappings = {
//   "nl-BE": "DLG-NL-BE",
//   "fr-BE": "DLG-FR-BE",
//   "de-CH": "DLG-DE-CH",
//   "fr-CH": "DLG-FR-CH",
//   "en-GB": "DLG",
// };

// export const getReevooCode = (localeId) => {
//   const countryCode = localeId.split('-')[1]
//   return specialCountryMappings[localeId] || `DLG-${countryCode}`
// }

export const getReviewConfig = (localeId, bazaarVoiceConfigPerCountry, feefoConfigurationPerCountry) => {
  const {customParams} = getConfig()
  const isProduction = customParams?.isProduction

  let baseConfig = {}
  if (bazaarVoiceConfigPerCountry && bazaarVoiceConfigPerCountry.enabled) {
    baseConfig = bazaarVoiceConfigPerCountry
  } else if (feefoConfigurationPerCountry && feefoConfigurationPerCountry.enabled) {
    baseConfig = feefoConfigurationPerCountry
  }

  if (!baseConfig) {
    return null
  }

  if (baseConfig?.provider === 'feefo') {
    return baseConfig
  }

  return {
    ...baseConfig,
    environment: isProduction ? 'production' : 'staging'
  }
}

export default baseReviewConfig
